import { useEffect, useState, Fragment } from 'react';
import axios from 'axios';
import { Card, Typography } from "@material-tailwind/react";
import ModalEditVideowall from './ModalEditVideowall';
import ModalCreateVideowall from './ModalCreateVideowall';

function ListVideowall() {
    const [datas, setDate] = useState([]);
    const [sortedBy, setSortedBy] = useState();
    const [counter, setCounter] = useState(0);
    const [search, setSearch] = useState('');

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedServer, setSelectedServer] = useState(null);

    const [showModal, setShowModal] = useState(false);


    let token = localStorage.getItem("token");

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };
    const data = { token: token };

    // Fonction pour charger les données
    const fetchData = () => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_grouped_clients_videowall`, data, { headers })
            .then(res => {
                setDate(res.data);
            }).catch(err => console.log(err));
    };

    useEffect(() => {
        fetchData();
    }, []);


    // --- Nouvelle fonction pour ouvrir le modal ---
    const handleOpenModal = (serverData) => {
        setSelectedServer(serverData);
        setIsModalOpen(true);
    };

    // --- Nouvelle fonction pour rafraîchir la liste après une modif ---
    const handleUpdateAndClose = () => {
        setIsModalOpen(false);
        setSelectedServer(null);
        // Re-charger les données pour voir les modifications
        fetchData();
    };

    const TABLE_HEAD = [
        { key: "nom", text: "Nom" },
        { key: "pin_code_serveur", text: "Pin Code Serveur" },
        { key: "pin_code_clients", text: "Pin Code Clients" },
        { key: "edit", text: "Edit" }
    ];

    const sorted = datas.sort((a, b) => {
        const aVal = a[sortedBy];
        const bVal = b[sortedBy];
        if (typeof aVal === "number" && typeof bVal === "number") {
            return counter % 2 === 0 ? aVal - bVal : bVal - aVal;
        } else if (typeof aVal === "string" && typeof bVal === "string") {
            return counter % 2 === 0 ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
        }
        return 1;
    });

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const handleCreateAndClose = () => {
        setShowModal(false);
        fetchData();
    };

    const ListTable = () => {
        return (
            <Card className="w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="overflow-x-auto">
                    <table className="w-full min-w-max table-auto text-left">
                        <thead className="border-b border-slate-200 bg-slate-50">
                            <tr>
                                {TABLE_HEAD.map((head) => (
                                    <th
                                        key={head.key}
                                        className="cursor-pointer whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
                                        onClick={() => { setSortedBy(head.key); setCounter(counter + 1) }}
                                    >
                                        <span className="inline-flex items-center gap-1">
                                            {head.text}
                                            {sortedBy === head.key && (
                                                <span className="text-indigo-500">{counter % 2 === 0 ? '▲' : '▼'}</span>
                                            )}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {sorted.filter((item) => {
                                return search.toLowerCase() === ''
                                    ? item
                                    : item.nom.toLowerCase().includes(search.toLowerCase()) ||
                                    item.pin_code_serveur.toLowerCase().includes(search.toLowerCase()) ||
                                    item.pin_code_clients.toLowerCase().includes(search.toLowerCase());
                            }).map((data, index) => {
                                const classes = "whitespace-nowrap px-4 py-3 text-sm text-slate-700";

                                return (
                                    <tr key={data.pin_code_serveur} className="border-b border-slate-100 transition-colors hover:bg-indigo-50/40">
                                        <td className={classes}>
                                            <Typography variant="small" className="font-medium text-slate-800">
                                                {data.nom}
                                            </Typography>
                                        </td>
                                        <td className={classes}>
                                            <Typography variant="small" className="font-normal text-slate-700">
                                                {data.pin_code_serveur}
                                            </Typography>
                                        </td>
                                        <td className={classes}>
                                            <Typography variant="small" className="font-normal text-slate-700">
                                                {data.pin_code_clients}
                                            </Typography>
                                        </td>
                                        <td className={classes}>
                                            <button
                                                onClick={() => handleOpenModal(data)}
                                                className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600"
                                            >
                                                Gérer
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Card>
        );
    };

    return (
        <Fragment>
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
                {/* <Header /> */}
                <div className="mb-6">
                    <h1 className="text-xl font-semibold text-slate-800">Video Walls</h1>
                    <p className="text-sm text-slate-500">Gérez vos groupes de murs d'écrans, serveurs et clients.</p>
                </div>
                <div className="mb-4 max-w-md">
                    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 absolute left-1 cursor-pointer" onClick={() => setOpen(open === `hidden`  ? 'block' : 'hidden')} >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg> */}
                    <div className="relative flex h-10 items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20">
                        <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                            type="text"
                            id="search"
                            placeholder="Rechercher un video wall..."
                            onChange={(e) => setSearch(e.target.value)} />
                    </div>
                </div>
                <main className="mt-4">
                    {ListTable()}
                    <button type="button" onClick={() => scrollToTop()} className="fixed bottom-20 right-6 flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md hover:bg-slate-50">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </button>
                    <button type="button" onClick={() => setShowModal(true)} className="fixed bottom-6 right-6 flex h-12 w-12 items-center justify-center rounded-full bg-indigo-500 text-white shadow-lg hover:bg-indigo-600">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </button>
                </main>
                {selectedServer && (
                    <ModalEditVideowall
                        isVisible={isModalOpen}
                        onClose={handleUpdateAndClose} // Utilise la fonction qui rafraîchit
                        serverData={selectedServer}
                    />
                )}

                <ModalCreateVideowall
                    isVisible={showModal}
                    onClose={handleCreateAndClose}
                />
            </div>
        </Fragment>
    );
}
export default ListVideowall;
